module.exports = "/assets/src/client/assets/payment-icons/mollie/applepay.svg";